<app-toast></app-toast>
<app-delete-confirmation-dialog title="{{ 'shared.delete' | transloco }}?"
    body="{{ 'admin.are_you_sure_delete_item' | transloco }}"></app-delete-confirmation-dialog>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full max-w-ultrawide">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full max-w-ultrawide">
        <app-admin-navigation [isActiveNumber]="10"></app-admin-navigation>
    </div>

    <div class="flex w-full max-w-ultrawide mobile:flex-col desktop:justify-between items-center">
        <div class="flex flex-col gap-2">
            <!-- Header -->
            <div class="flex gap-2 w-full mt-4 max-w-ultrawide">
                <img src="assets/icons/services/target-green.svg" class="w-[24px] h-[24px]"
                    alt="{{ 'shared.icon' | transloco }}">
                <h1 class="font-bold text-xl">
                    {{ 'admin.opportunities' | transloco }}</h1>
            </div>
            <p class="text-neutral-500 self-start mt-2"> {{ 'admin.opportunities_desc' | transloco }}</p>
        </div>

        <div class="w-[250px] h-[50px]">
            <app-custom-button buttonText="{{ 'admin.create_opportunity' | transloco }}"
                leadingIcon="assets/icons/add.svg" backgroundColor="bg-success" textColor="text-white"
                borderColor="border-success" hoverBorderColor="hover:border-success-600"
                hoverBackgroundColor="hover:bg-success-600" (buttonClick)="createOpportunity()"></app-custom-button>
        </div>
    </div>

    <!-- Content -->
    <div class="w-full max-w-ultrawide mt-4" #editCreateRef>

        <!-- Edit/Create-->
        <app-create-edit-opportunity [(isOpen)]="isEditCreateOpen" [isEditing]="isEditing"
            [opportunity]="selectedOpportunity" [toast]="toast"
            [reloadCallbackFunction]="reloadOpportunities"></app-create-edit-opportunity>

        <!-- Card -->
        <div class="relative w-full rounded-xl border border-border shadow-md"
            *ngFor="let opportunity of opportunities">
            <!-- Top actions (edit/delete) -->
            <div class="absolute right-3 top-3 flex items-center gap-3 text-neutral-400">
                <!-- Edit -->
                <button title="{{ 'settings.button.edit' | transloco }}" class="p-1 rounded hover:bg-secondary-200"
                    (click)="editOpportuniry(opportunity)">
                    <img src="assets/icons/edit.svg" alt="{{ 'settings.button.edit' | transloco }}" class="w-6 h-6" />
                </button>
                <!-- Delete -->
                <button title="{{ 'shared.delete' | transloco }}" (click)="deleteOpportunity(opportunity)">
                    <svg width="24" height="24" viewBox="0 0 50 50">
                        <circle cx="25" cy="25" r="24" fill="#FF0000" />
                        <image href="assets/icons/delete.svg" x="12" y="12" height="25px" width="25px" />
                    </svg>
                </button>
            </div>

            <!-- Body -->
            <div class="p-6">
                <p class="font-bold text-lg">{{ opportunity.name }}</p>

                <!-- Product-->
                <div class="mt-2 text-sm text-neutral-500">
                    <span class="inline-block font-medium text-neutral-500">{{'admin.products_services' |
                        transloco}}:</span>
                </div>

                <p class="mt-4 text-neutral-700">
                    {{ opportunity.product.name }}
                </p>

                <!-- Description -->
                <div class="mt-2 text-sm text-neutral-500">
                    <span class="inline-block font-medium text-neutral-500">{{ 'admin.description' | transloco}}:</span>
                </div>

                <p class="mt-4 text-neutral-700">
                    {{ opportunity.description }}
                </p>


            </div>
        </div>
    </div>
</div>